module.exports = __webpack_public_path__ + "img/10869_L.8d605ea7.png";